import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { PageContentCard } from '../components';
import { BackLink } from 'enrollment/components';
import { Loader } from 'theSource/components';
import { usePageContentQuery } from 'enrollment/queries/usePageContentQuery';

export const BenefitInformation = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('pages.benefitsInformation');
  const { slotNum } = useParams();

  // the below query will pull from cache based on 'dashboard/initial' as the id
  const { pageContent, isFetchingPageContent, isLoadingPageContent } =
    usePageContentQuery({ pageContentLookupCode: 'dashboard/initial' });
  const isLoadingContentBlocks = isFetchingPageContent || isLoadingPageContent;
  const contentBlocks = pageContent?.data.content_blocks;

  const contentBlock = contentBlocks?.find(
    (contentBlock) => contentBlock.slot_num === Number(slotNum)
  );

  useEffect(() => {
    if (!isLoadingContentBlocks && (!slotNum || !contentBlocks || !contentBlock)) {
      navigate(`/`);
    }
  }, [slotNum, isLoadingContentBlocks, contentBlocks, navigate, contentBlock]);

  if (isLoadingContentBlocks) {
    return <Loader />;
  }

  return (
    <Box data-testid="benefit-information" className="tablet">
      <div>
        <BackLink
          underline={false}
          testId="back-button"
          className="mb-5"
          defaultPath='/'
        />
      </div>
      <h1 className="sub-page">{t('infoTitle')}</h1>
      {contentBlock && (
        <PageContentCard
          slotNum={contentBlock.slot_num}
          iconImage={contentBlock.icon_image}
          content={contentBlock.content}
          label={contentBlock.label}
          documents={contentBlock.documents}
          url={contentBlock.url}
          urlType={contentBlock.url_type}
          extraClass="single"
          fullContentCard
        />
      )}
    </Box>
  );
};
